
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/module/[slug]",
      function () {
        return require("private-next-pages/courses/module/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/module/[slug]"])
      });
    }
  